(function () {
  'use strict';

  if (window.MinibundleProduct) return;

  // _bundle_labels 를 잇는 구분자. 카트 템플릿이 이 문자열로 다시 쪼갠다
  // (sections/cart-template.liquid) — 한쪽만 바꾸면 표시가 깨진다.
  var LABEL_SEPARATOR = ' / ';

  // 라벨 안에 구분자와 같은 문자열이 들어가면 카트 표시가 한 줄씩 밀린다. 상품명은
  // 운영자가 바꾸는 값이므로 여기서 막는다(구분자를 바꾸려면 카트 템플릿도 함께).
  function sanitizeLabel(value) {
    return String(value == null ? '' : value).split(LABEL_SEPARATOR).join(' ');
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init(sectionEl) {
    if (sectionEl.dataset.minibundleInitialized) return;

    var sectionId = sectionEl.getAttribute('data-section-id');
    var dataEl = document.getElementById('MinibundleData-' + sectionId);
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      console.error('[MinibundleProduct] MinibundleData JSON parse error', e);
      return;
    }

    sectionEl.dataset.minibundleInitialized = 'true';

    var catalog = Array.isArray(data.pool) ? data.pool : [];
    var slotState = {};
    var slotEls = $$('[data-minibundle-slot]', sectionEl);
    var totalSlots = slotEls.length;

    var accordion = createAccordion(slotEls);

    slotEls.forEach(function (slotEl) {
      initSlot(slotEl, catalog, slotState, accordion, function (changedEl, becameComplete) {
        updateProgress(sectionEl, slotState, totalSlots);
        if (becameComplete) advanceAccordion(slotEls, slotState, accordion, changedEl);
      });
    });

    // 첫 슬롯만 열고 시작. 마크업 기본값이 '열림'이라 이 호출이 나머지를 닫는다.
    if (slotEls.length) accordion.open(slotEls[0]);

    updateProgress(sectionEl, slotState, totalSlots);

    var addBtn = $('#MinibundleAddToCart-' + sectionId, sectionEl);
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        submitToCart(sectionEl, data, slotState, totalSlots, slotEls);
      });
    }
  }

  // 아코디언 — 한 번에 하나의 슬롯만 열어둔다. 열림 상태는 slot의
  // data-slot-open 속성 하나로만 표현하고 표시는 전부 CSS가 담당한다.
  // 기본값(속성 없음)은 '열림'이라 JS가 죽어도 전 슬롯이 펼쳐진 채로 쓸 수 있다.
  function createAccordion(slotEls) {
    function setOpen(slotEl, open) {
      slotEl.setAttribute('data-slot-open', open ? 'true' : 'false');
      var toggle = $('[data-slot-toggle]', slotEl);
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    return {
      open: function (target) {
        slotEls.forEach(function (el) { setOpen(el, el === target); });
      },
      closeAll: function () {
        slotEls.forEach(function (el) { setOpen(el, false); });
      },
      toggle: function (slotEl) {
        if (slotEl.getAttribute('data-slot-open') === 'false') this.open(slotEl);
        else setOpen(slotEl, false);
      }
    };
  }

  // 슬롯이 방금 완성됐을 때 다음 미완성 슬롯으로 자동 이동. 전부 완성되면
  // 모두 접어 진행률/담기 버튼이 스크롤 없이 보이게 한다.
  function advanceAccordion(slotEls, slotState, accordion, changedEl) {
    var next = null;
    for (var i = 0; i < slotEls.length; i++) {
      if (slotEls[i] === changedEl) continue;
      var id = slotEls[i].getAttribute('data-slot-id');
      if (!(slotState[id] && slotState[id].variantId)) { next = slotEls[i]; break; }
    }
    if (next) accordion.open(next);
    else accordion.closeAll();
  }

  // 상품(색상) 전체가 품절인지 — 하나라도 available variant가 있으면 재고 있음.
  function colorHasStock(entry) {
    return (entry.variants || []).some(function (v) { return v.available; });
  }

  function findCatalogEntry(catalog, productId) {
    for (var i = 0; i < catalog.length; i++) {
      if (String(catalog[i].productId) === String(productId)) return catalog[i];
    }
    return null;
  }

  function initSlot(slotEl, catalog, slotState, accordion, onChange) {
    var slotId = slotEl.getAttribute('data-slot-id');
    var colorGroupEl = $('[data-color-group]', slotEl);
    var powerSelectEl = $('[data-power-select]', slotEl);
    var statusEl = $('[data-slot-status]', slotEl);
    var toggleEl = $('[data-slot-toggle]', slotEl);

    slotState[slotId] = { variantId: null, productId: null, power: null };

    if (toggleEl) {
      toggleEl.addEventListener('click', function () {
        accordion.toggle(slotEl);
      });
    }

    populateColorGroup(colorGroupEl, catalog, function (productId) {
      var entry = findCatalogEntry(catalog, productId);
      slotState[slotId].productId = productId;
      slotState[slotId].variantId = null;
      slotState[slotId].power = null;
      populatePowerSelect(powerSelectEl, entry ? entry.variants : []);
      powerSelectEl.disabled = !entry;
      updateSlotStatus(slotEl, statusEl, slotState[slotId], catalog);
      // 색상만 고른 단계 — 도수가 남았으니 슬롯을 넘기지 않는다.
      onChange(slotEl, false);
    });

    powerSelectEl.addEventListener('change', function () {
      var wasComplete = !!slotState[slotId].variantId;
      var variantId = powerSelectEl.value;
      if (!variantId) {
        slotState[slotId].variantId = null;
        slotState[slotId].power = null;
      } else {
        slotState[slotId].variantId = variantId;
        var selectedOpt = powerSelectEl.options[powerSelectEl.selectedIndex];
        slotState[slotId].power = selectedOpt.getAttribute('data-power');
      }
      updateSlotStatus(slotEl, statusEl, slotState[slotId], catalog);
      // 이미 완성된 슬롯의 도수만 바꾼 경우엔 자동 이동하지 않는다(사용자가
      // 그 슬롯을 다시 열어 수정하는 중이므로 화면을 빼앗으면 안 된다).
      onChange(slotEl, !wasComplete && !!slotState[slotId].variantId);
    });
  }

  // 컬러 풀 전체를 버튼 그룹으로 렌더. 모든 슬롯이 동일한 목록을 공유한다
  // (슬롯 위치가 특정 상품에 묶이지 않음 — docs/feature-minibundle.md §1-1).
  function populateColorGroup(groupEl, catalog, onSelect) {
    var unavailableSuffix = groupEl.getAttribute('data-unavailable-suffix') || '';
    groupEl.innerHTML = '';

    catalog.forEach(function (entry) {
      var hasStock = colorHasStock(entry);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'Minibundle__ColorSwatch';
      btn.setAttribute('aria-pressed', 'false');
      btn.disabled = !hasStock;

      // 라벨 텍스트가 접근가능한 이름을 제공하므로 이미지는 장식으로 처리(alt='').
      if (entry.image) {
        var img = document.createElement('img');
        img.src = entry.image;
        img.alt = '';
        img.loading = 'lazy';
        btn.appendChild(img);
      }

      // 상품명은 Liquid가 내보낸 product.title 원문을 그대로 쓴다 — 코드에서
      // 자르거나 조합하지 않는다(품절 표기 접미사만 뒤에 붙는다).
      var labelSpan = document.createElement('span');
      labelSpan.className = 'Minibundle__ColorSwatchLabel';
      labelSpan.textContent = (entry.label || '') + (hasStock ? '' : unavailableSuffix);
      btn.appendChild(labelSpan);

      btn.addEventListener('click', function () {
        $$('.Minibundle__ColorSwatch', groupEl).forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        onSelect(entry.productId);
      });

      groupEl.appendChild(btn);
    });
  }

  function populatePowerSelect(selectEl, variants) {
    var placeholderText = selectEl.getAttribute('data-placeholder') || '';
    var unavailableSuffix = selectEl.getAttribute('data-unavailable-suffix') || '';

    while (selectEl.options.length) selectEl.remove(0);
    var placeholder = document.createElement('option');
    placeholder.value = '';
    placeholder.textContent = placeholderText;
    selectEl.appendChild(placeholder);

    (variants || []).forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = String(v.id);
      opt.setAttribute('data-power', v.power || '');
      opt.textContent = (v.power || '') + (v.available ? '' : unavailableSuffix);
      if (!v.available) opt.disabled = true;
      selectEl.appendChild(opt);
    });
  }

  function updateSlotStatus(slotEl, statusEl, state, catalog) {
    var emptyText = statusEl.getAttribute('data-status-empty') || '';
    var completeText = statusEl.getAttribute('data-status-complete') || '';
    var thumbEl = $('[data-summary-thumb]', slotEl);
    var textEl = $('[data-summary-text]', slotEl);

    if (state.variantId) {
      slotEl.setAttribute('data-slot-complete', 'true');
      statusEl.textContent = completeText;

      var entry = findCatalogEntry(catalog, state.productId);
      var label = (entry && entry.label) || '';
      if (thumbEl) {
        if (entry && entry.image) {
          thumbEl.src = entry.image;
          thumbEl.hidden = false;
        } else {
          thumbEl.removeAttribute('src');
          thumbEl.hidden = true;
        }
      }
      if (textEl) textEl.textContent = state.power ? (label + ' / ' + state.power) : label;
    } else {
      slotEl.removeAttribute('data-slot-complete');
      statusEl.textContent = emptyText;
      if (thumbEl) {
        thumbEl.removeAttribute('src');
        thumbEl.hidden = true;
      }
      if (textEl) textEl.textContent = '';
    }
  }

  function updateProgress(sectionEl, slotState, totalSlots) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var selected = Object.keys(slotState).filter(function (k) {
      return slotState[k].variantId;
    }).length;
    var remaining = totalSlots - selected;

    var progressEl = $('#MinibundleProgress-' + sectionId, sectionEl);
    var addBtn = $('#MinibundleAddToCart-' + sectionId, sectionEl);

    // 남은 개수 안내는 미완료일 때만 띄운다. 전부 고르면 문단 자체를 숨긴다 —
    // 완료 사실은 담기 버튼이 활성화되는 것으로 충분히 전달된다(2026-08-18 피드백:
    // 완료 문구가 버튼처럼 보여 오해를 샀다).
    if (progressEl) {
      if (remaining === 0) {
        progressEl.classList.add('hidden');
        progressEl.textContent = '';
      } else {
        var tmpl = progressEl.getAttribute('data-progress-template') || '';
        progressEl.textContent = tmpl.replace('__N__', String(remaining));
        progressEl.classList.remove('hidden');
      }
    }
    if (addBtn) addBtn.disabled = (remaining !== 0);
  }

  function submitToCart(sectionEl, data, slotState, totalSlots, slotEls) {
    var sectionId = sectionEl.getAttribute('data-section-id');
    var addBtn = $('#MinibundleAddToCart-' + sectionId, sectionEl);
    var errorEl = $('#MinibundleError-' + sectionId, sectionEl);
    // 라벨은 상품 상세 버튼과 같은 .cart-text 스팬이다(마크업을 맞췄으므로).
    var labelEl = addBtn ? addBtn.querySelector('.cart-text') : null;

    var labelDefault = (addBtn && addBtn.getAttribute('data-label-default')) || '';
    var labelAdding = (addBtn && addBtn.getAttribute('data-label-adding')) || '';
    var labelAdded = (addBtn && addBtn.getAttribute('data-label-added')) || '';
    var errIncomplete = (addBtn && addBtn.getAttribute('data-error-incomplete')) || '';
    var errCartAdd = (addBtn && addBtn.getAttribute('data-error-cart-add')) || '';
    var errExpand = (addBtn && addBtn.getAttribute('data-error-expand')) || errCartAdd;

    var selectedKeys = Object.keys(slotState).filter(function (k) { return slotState[k].variantId; });
    if (selectedKeys.length !== totalSlots) {
      showError(errorEl, errIncomplete);
      return;
    }

    hideError(errorEl);
    if (addBtn) addBtn.disabled = true;
    if (labelEl) labelEl.textContent = labelAdding;

    // expand 전환(2026-08-19): 카트에는 세트 1줄만 담긴다. 구성품은 property로
    // 실리고, 그 1줄을 Cart Transform Function이 lineExpand로 펼친다.
    // 라인이 1개라 순서 보정(구 reverse)은 의미가 없어졌다 — docs/feature-minibundle-expand.md §3-1.
    var items = buildCartItems(data, slotState, slotEls);

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (j) { throw j; });
        return res.json();
      })
      .then(function () {
        // 펼쳐졌는지 확인한다. `requiresComponents`(구성품 없이 판매 금지)를 우리 구조에서는
        // 쓸 수 없음이 확인됐으므로(shopify-apps docs/Feature-bundle-expand.md §3-5),
        // 펼치기 실패가 결제까지 흘러가면 **렌즈 없는 ¥1,500 주문**이 만들어진다.
        // 실패 원인은 대개 운영자 조치 대상이다(허용 구성품 동기화 누락, 앱 등록 해제).
        // 여기서 그 라인을 되돌리는 것이 유일한 방어선이다.
        return fetch('/cart.js', { credentials: 'include' })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var items = (cart && cart.items) || [];
            var line = null;
            for (var i = 0; i < items.length; i++) {
              var props = items[i].properties;
              if (props && props._bundle_items) { line = items[i]; break; }
            }
            if (line && line.has_components) return;

            // 펼쳐지지 않았다 → 담은 것을 되돌리고 실패로 처리한다.
            if (!line) throw { __minibundleExpandFailed: true };
            return fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: line.key, quantity: 0 })
            }).then(function () { throw { __minibundleExpandFailed: true }; });
          });
      })
      .then(function () {
        // 헤더 미니카트(#dropdown-cart)를 실제로 갱신하는 jewelias.updateDropdownCart()는
        // assets/jewelias.min.js의 IIFE 안에 갇힌 지역변수라 window.jewelias로 접근 불가
        // (실측 확인됨 — window.jewelias는 항상 undefined). 이 함수를 대신 호출하거나
        // monkey-patch할 방법이 없고, 다른 상품의 네이티브 담기가 쓰는 커스텀 이벤트
        // 훅도 이 테마엔 없음(grep 확인). 유일하게 안전한 방법은 페이지를 새로고침해
        // jewelias의 캐시된 jQuery 셀렉터(#dropdown-cart 등)를 포함해 헤더 전체를
        // 다시 SSR 렌더하는 것 — 이러면 카운트뱃지·드롭다운·자식 라인 은닉이
        // 전부 기존 검증된 Liquid 경로로 정확히 반영된다.
        if (labelEl) labelEl.textContent = labelAdded;
        setTimeout(function () {
          window.location.reload();
        }, 600);
      })
      .catch(function (err) {
        console.error('[MinibundleProduct] cart/add error', err);
        // 422 = 재고 부족/구매 불가. expand 전환 후 담기에 들어가는 것은 세트 라인
        // 1줄뿐이라, 고른 렌즈의 품절은 여기서 걸리지 않고 카트/체크아웃에서
        // 드러난다(docs/feature-minibundle-expand.md §5). 즉 이 422는 세트 상품
        // 자체를 담을 수 없을 때만 난다 — 문구는 그대로 두되 의미가 달라졌다.
        var msg;
        if (err && err.__minibundleExpandFailed) {
          // 재고 문구로 뭉개면 안 된다 — 고객이 다른 색을 골라도 해결되지 않는다.
          msg = errExpand;
        } else if (err && (err.status === 422 || err.status === '422')) {
          msg = errCartAdd;
        } else {
          msg = (err && err.description) || (err && err.message) || errCartAdd;
        }
        showError(errorEl, msg);
        if (addBtn) addBtn.disabled = false;
        if (labelEl) labelEl.textContent = labelDefault;
      });
  }

  // 고정 구성품(케이스 등) 목록. Liquid가 minibundle.fixed_items를 배열로 내보낸다.
  // 미등록이면 빈 배열 → 구성품 라인 없이 담긴다.
  function getFixedItems(data) {
    return Array.isArray(data.fixedItems) ? data.fixedItems : [];
  }

  // 세트(parent) 카트 라인 1줄을 만든다. 고객이 고른 구성품은 line property로
  // 실어 보내고, 실제로 라인을 펼치는 것은 Cart Transform Function이다.
  //
  // 계약(앱과 동시 수정 — docs/feature-minibundle-expand.md §2):
  //   _bundle_items  구성품 variant id를 쉼표로 이은 문자열. 이 키의 존재가 펼치기의 유일한 트리거
  //   _bundle_labels 같은 순서·같은 개수의 표시용 문자열. Function은 읽지 않지만,
  //                  Liquid는 variant id로 variant를 역조회할 수 없고 /cart.js도 구성품을
  //                  나열하지 않으므로 카트에 구성을 보여줄 유일한 수단이다
  //   _bundle_v      구조 판별용 버전
  //
  // ⚠️ 순서가 계약이다(고정 구성품 → 슬롯 1~4). 앱이 세트 가격을 구성품에 나눌 때
  //    나머지를 첫 구성품에 붙이고, 주문서 표시 순서도 이 순서를 따른다. 그래서
  //    슬롯은 Object.keys(slotState)가 아니라 DOM 순서로 뽑는다.
  //    두 배열은 반드시 같은 루프에서 같이 채운다 — 길이가 어긋나면 표시가 밀린다.
  function buildCartItems(data, slotState, slotEls) {
    var ids = [];
    var labels = [];
    var catalog = Array.isArray(data.pool) ? data.pool : [];

    // 1. 고정 구성품 (케이스 등 — 등록된 것만, 등록 순서대로)
    getFixedItems(data).forEach(function (item) {
      if (!item || !item.variantId) return;
      ids.push(item.variantId);
      labels.push(sanitizeLabel(item.title));
    });

    // 2. 슬롯 1~4 (DOM 순서)
    (slotEls || []).forEach(function (slotEl) {
      var slotId = slotEl.getAttribute('data-slot-id');
      var s = slotState[slotId];
      if (!s || !s.variantId) return;
      ids.push(s.variantId);
      // 상품명은 Liquid가 내보낸 product.title 원문 그대로(슬롯 요약 표시와 동일 규칙).
      var entry = findCatalogEntry(catalog, s.productId);
      var label = (entry && entry.label) || '';
      // 도수는 괄호로 감싼다 — 상품명 자체에 하이픈이 들어 있어(「… 1Day - グレー」)
      // 하이픈으로 이으면 도수의 마이너스까지 겹쳐 「- -1.25」로 읽힌다.
      labels.push(sanitizeLabel(s.power ? (label + ' (' + s.power + ')') : label));
    });

    return [{
      id: data.bundleMain.variantId,
      quantity: 1,
      properties: {
        _bundle_items: ids.join(','),
        _bundle_labels: labels.join(LABEL_SEPARATOR),
        _bundle_v: '2'
      }
    }];
  }

  function showError(el, msg) {
    if (!el) return;
    el.textContent = msg;
    el.classList.remove('hidden');
  }
  function hideError(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.add('hidden');
  }

  function initAll() {
    $$('[data-section-type="minibundle-product"]').forEach(init);
  }

  window.MinibundleProduct = { init: init, initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify section reload (Customize editor)
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('[data-section-type="minibundle-product"]');
    if (section) init(section);
  });
})();
